import React  from "react";

import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Container,
  Row, 
} from "reactstrap"; 
import "../../../assets/css/Finance/Style/Finance GST/financegst.css";

import ZithasGST from "./ZithasGST";
import StaffGuruGST from "./StaffGuruGST";

// components

const GstFinance = () => { 
 

  document.title = "GST | Zithas Technologies"; 

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"GST"} />

          <Row>
            <div className="col-12 ps-0">
              <ZithasGST />
            </div>
          </Row>

          {/* <Row className="gx-4 justify-content-between di-flex align-items-top">
            <Col md="2" className="px-0">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3
                            ${fixedSideTab ? "fixed-side-tab" : ""} h-100`}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                    Zithas Technologies Pvt Ltd
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                    Staff Guru
                  </NavLink>
                </NavItem>
                
              </Nav>
            </Col>
            <Col md="10 pe-0">
              <div className=" bg-transparent mb-0" id="edit-lead">
             
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <ZithasGST
                    //   editData={lead_data[0] || []}
                    //   industry_option={industry_option}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <StaffGuruGST
                    //   noteData={note_data || []}
                    //   assigned={assigned_data || []}
                    />
                  </TabPane>
                 
                </TabContent>
              </div>
            </Col>
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GstFinance;
